// Color tokens lifted verbatim from the VIP Portal Figma file
// (zEkYrJyCG6k6PFhmqsfmFz). Shared by RevisedPOReview, CreditNoteSubmission,
// and CreditNoteRequiredDialog. Keep this in sync if the Figma palette
// changes for the post-invoice PO edit screens.
export const TOKENS = {
  surfaceBg: "#F2F2F2",
  surfaceDefault: "#FFFFFF",
  surfaceVariant: "#E6E6E6",
  onSurfaceDefault: "#1A1A1A",
  onSurfaceSecondary: "#666666",
  onSurfaceBorder: "#CCCCCC",
  onSurfaceDisabled: "#999999",
  primaryDefault: "#3655F2",
  tertiaryBlueDefault: "#4E58B4",
  tertiaryBlueVariant1: "#DCDEF0",
  tertiaryBlueVariant2: "#EDEEF7",
  onTertiaryBlueVariant: "#3E4690",
  tertiaryYellowVariant1: "#FCECD5",
  tertiaryYellowVariant2: "#FEF5EA",
  onTertiaryYellowVariant: "#C17E22",
  tertiaryGreenDefault: "#469E59",
  tertiaryRedDefault: "#DB382A",
  tertiaryRedVariant1: "#F8D6D2",
  tertiaryRedVariant2: "#FCEBE9",
  onTertiaryRedVariant: "#A12B20",
};
